<template>
 <div class="wrapper">
   <div class="faq-wrap">
    <v-accordion-item
    v-for="item in faq_data"
    :key="item.id"
    :item_date="item"
    />
    <!-- <p 
    v-for="item in faq_data"
    :key="item.id">
    {{item.question}}
    </p> -->
   </div>
 </div>
</template>

<script>
import vAccordionItem from './v-accordion-item.vue';
export default {
 components:{
  vAccordionItem
 },
 props: {
  faq_data:{
   type: Array,
   default: ()=>[]
  }
 }
}
</script>

<style lang="sass" scoped>
.wrapper
 width: 800px
 .faq-wrap
  border: solid .5px #000
  border-radius: 15px
@media screen and (max-width: 700px)
  .wrapper
    width: 100%
    padding: 0 20px
</style>


